import { useDispatch, useSelector } from "react-redux";
import {
  nextPage,
  updateBasicDetails,
  setDate,
} from "../../redux/onBoardStore";
import DatePicker from "react-datepicker";
import { BsCalendarDate } from "react-icons/bs";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";
import { useState, useRef, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TimePicker from "../TimePicker";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { useNavigate } from "react-router-dom";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { parsePhoneNumber } from "react-phone-number-input";
import axios from "axios";
import { useLocation } from "react-router-dom";
const options = [
  { value: "phone", label: "Phone" },
  { value: "virtualMeeting", label: "Virtual Meeting" },
  { value: "inPerson", label: "In Person" },
];
const allowedCountries = ["KE", "ET", "NG"];

const BasicInfo = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("q");

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { selectedDate } = useSelector((state) => state.form);
  const formRef = useRef(null);
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [value, setValue] = useState();

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");

  // Fetch states on component mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(
          `https://countriesnow.space/api/v0.1/countries/`
        );
        const filteredCountries = response.data.data.filter((country) =>
          allowedCountries.includes(country.iso2)
        );

        setCountries(filteredCountries);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  // Fetch states when a country is selected
  useEffect(() => {
    const fetchStates = async () => {
      if (!selectedCountry) return;
      try {
        const response = await axios.post(
          `https://countriesnow.space/api/v0.1/countries/states`,
          {
            country: selectedCountry,
          }
        );

        setStates(response.data.data.states);
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    fetchStates();
  }, [selectedCountry]);

  // Fetch cities when a state is selected
  useEffect(() => {
    const fetchCities = async () => {
      if (!selectedState) return;
      try {
        const response = await axios.post(
          `https://countriesnow.space/api/v0.1/countries/state/cities`,
          {
            country: selectedCountry,
            state: selectedState,
            // selectedState === "Abuja"
            //   ? "Federal Capital Territory"
            //   : selectedState,
          }
        );
        setCities(response.data.data);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };

    fetchCities();
  }, [selectedState]);

  const handleDateChange = (date) => {
    dispatch(setDate(date.toLocaleDateString()));
  };

  const updateLocalStorage = (formValues) => {
    localStorage.setItem("formValues", JSON.stringify(formValues));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevState) => ({ ...prevState, [name]: value }));
    setFormErrors((prevState) => ({ ...prevState, [name]: "" }));
    updateLocalStorage({ ...formValues, [name]: value });
  };
  const handlePhoneChange = (newPhone) => {
    const formattedPhone = formatPhoneNumberIntl(newPhone);
    const phoneObj = parsePhoneNumber(formattedPhone);
    if (phoneObj && phoneObj.countryCallingCode) {
      const { countryCallingCode, nationalNumber } = phoneObj;

      // Validate length for Nigeria (and other countries if needed)
      const isValidLength =
        (phoneObj.country === "NG" && nationalNumber.length === 10) ||
        (phoneObj.country === "KE" && nationalNumber.length === 9) ||
        (phoneObj.country === "ET" && nationalNumber.length === 9);

      if (!isValidLength) {
        setFormErrors((prevState) => ({
          ...prevState,
          phone: "Invalid phone number",
        }));
        return;
      }

      setValue(formattedPhone);
      setFormValues((prevState) => ({
        ...prevState,
        phone: nationalNumber,
        countrycode: `+${countryCallingCode}`,
      }));
      setFormErrors((prevState) => ({
        ...prevState,
        phone: isValidPhoneNumber(formattedPhone) ? "" : "Invalid phone number",
      }));
      updateLocalStorage({
        ...formValues,
        phone: nationalNumber,
        countrycode: `+${countryCallingCode}`,
      });
    } else {
      setFormErrors((prevState) => ({
        ...prevState,
        phone: "Invalid phone number",
      }));
    }
  };
  useEffect(() => {
    const data = localStorage.getItem("formValues");
    if (data) {
      setFormValues(JSON.parse(data));
    }
  }, []);
  const validateFields = (values) => {
    const errors = {};
    if (!values.name) {
      errors.name = "Required";
    }
    if (!values.email) {
      errors.email = "Required";
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = "Invalid email address";
    }
    if (!values.phone) {
      errors.phone = "Required";
    }
    if (!values.hospital) {
      errors.hospital = "Required";
    }
    if (!values.country) {
      errors.country = "Required";
    }
    if (!values.city) {
      errors.city = "Required";
    }
    if (!values.state) {
      errors.state = "Required";
    }
    if (!values.time) {
      errors.time = "Required";
    }
    if (!values.preference) {
      errors.preference = "Required";
    }
    return errors;
  };
  const handleBasicDetailsSubmit = async (e) => {
    e.preventDefault();
    const form = formRef.current;
    const formData = new FormData(form);
    const values = Object.fromEntries(formData.entries());
    console.log("values", values);
    const errors = validateFields(values);
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      toast.error("Please fill all required fields.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
    } else {
      setFormErrors({});

      const phoneObj = parsePhoneNumber(values.phone);
      const { countryCallingCode, nationalNumber } = phoneObj;
      console.log("countryCallingCode", countryCallingCode);

      //  remove state from the selected state string
      const state = values.state.split(" ")[0];

      const details = {
        name: values?.name,
        date: values?.date,
        email: values?.email,
        hospital: values?.hospital,
        country: values?.country,
        city: values?.city,
        phone: values?.phone,
        time: values?.time,
        preference: values?.preference,
        q: id,
        state: state,
        phone: nationalNumber.replace(/\s/g, ""),
        countrycode: `+${countryCallingCode}`,
      };
      const updatedBasicDetails = {
        ...values,
        q: id,
        state: state,
        phone: nationalNumber.replace(/\s/g, ""),
        countrycode: `+${countryCallingCode}`,
      };

      delete values.phoneCountry;

      // console.log("values", values);
      setLoading(true);
      try {
        // const response = await axios.post(
        //   "https://one.lifebanktest.com/v1/marketing/basic/information",
        //   updatedBasicDetails
        // );

        const response = await axios.post(
          "https://one.lifebank.ng/api/v1/marketing/basic/information",
          updatedBasicDetails
        );

        // https://one.lifebank.ng/sale/
        setLoading(false);
        if (response.status !== 200) {
          throw new Error("Failed to submit data");
        }

        if (response.status === 200) {
          window.sessionStorage.setItem("responseID", response.data.id);
          dispatch(updateBasicDetails(updatedBasicDetails));
          dispatch(nextPage());
        }
      } catch (error) {
        console.log("eror", error);
        toast.error(
          "error occured, please check if have booked an appointment before now.",
          {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          }
        );

        // toast.error(
        //   "You have booked an appointment, you will be contacted shortly. Thanks"
        // );
        // console.error(error);
        setLoading(false);
      }
    }
  };
  window.onbeforeunload = () => {
    localStorage.clear();
  };
  const saveDraft = async (e) => {
    e.preventDefault();
    const form = formRef.current;
    const formData = new FormData(form);
    const values = Object.fromEntries(formData.entries());
    const errors = validateFields(values);
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      toast.error("Please fill all required fields.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
      return;
    }
    // Split phone number into country code and phone number
    const phoneObj = parsePhoneNumber(values.phone);
    const { countryCallingCode, nationalNumber } = phoneObj;
    const basicDetails = {
      ...values,
      q: id,
      phone: nationalNumber,
      countrycode: `+${countryCallingCode}`,
    };
    delete basicDetails.phoneCountry; // Exclude phoneCountry
    setFormErrors({});
    toast.success("Draft saved successfully.", {
      position: "top-center",
      autoClose: 6000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
    });
    try {
      // const response = await fetch(
      //   "https://one.lifebanktest.com/v1/marketing/basic/information",
      //   {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //     body: JSON.stringify(basicDetails),
      //   }
      // );

      const response = await fetch(
        "https://one.lifebank.ng/api/v1/marketing/basic/information",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(basicDetails),
        }
      );

      console.log("res", response);
      if (!response.ok) {
        throw new Error("Failed to submit data");
      }
      // navigate('/');
      dispatch(updateBasicDetails(basicDetails));
      // Reload the page
      // const timer = setTimeout(() => {
      //   window.location.reload();
      // }, 6000);
      // return () => clearTimeout(timer);
    } catch (error) {}
  };
  const excludeWeekends = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  };
  return (
    <>
      <form className="mt-10  z-100" id="basic-details-form" ref={formRef}>
        <div className="lg:min-w-full  mx-auto text-left">
          <label
            htmlFor="name"
            className="lg:text-lg text-sm  flex flex-start "
          >
            Name
          </label>
          <input
            type="text"
            className="w-full input lg:h-12 border-2 rounded-lg"
            name="name"
            onChange={handleInputChange}
            value={formValues.name || ""}
            placeholder='e.g "John Doe"'
          />
          {formErrors.name && (
            <div className="text-[#B70303]">{formErrors.name}</div>
          )}
        </div>

        <div className="flex flex-col lg:flex-row lg:justify-between lg:min-w-full  gap-1 mt-4 mx-auto">
          <div className="hospitalInput">
            <label htmlFor="hospitalName" className="lg:text-lg text-sm ">
              Hospital Name
            </label>
            <input
              type="text"
              name="hospital"
              className="input lg:h-12"
              onChange={handleInputChange}
              value={formValues.hospital || ""}
              placeholder='e.g "Lagos University Teaching Hospital"'
            />
            {formErrors.name && (
              <div className="text-[#B70303]">{formErrors.hospital}</div>
            )}
          </div>
          <div className="emailInput">
            <label htmlFor="email" className="lg:text-lg text-sm">
              Email
            </label>
            <input
              type="email"
              name="email"
              className="input"
              onChange={handleInputChange}
              value={formValues.email || ""}
              placeholder='e.g "johndoe@email.com"'
            />
            {formErrors.email && (
              <div className="text-[#B70303]">{formErrors.email}</div>
            )}
          </div>
        </div>
        <div className="lg:min-w-full  mx-auto mt-1 flex justify-start mb-4 px-2">
          <input type="checkbox" name="checked" className="checkbox" />
          <label htmlFor="currentWork" className="text-sm px-2">
            I currently work here
          </label>
        </div>
        <div className="flex flex-col lg:flex-row lg:justify-between justify-between gap-2   lg:min-w-full  mx-auto">
          <div className="hospitalInput">
            <label htmlFor="hospitalName" className="lg:text-lg text-sm">
              Phone Number
            </label>
            <PhoneInput
              addInternationalOption={false}
              defaultCountry="NG"
              countries={allowedCountries}
              className="input PhoneInputInput"
              autoComplete="on"
              inputstyle={{ width: "100%", outline: "none" }}
              name="phone"
              value={value}
              onChange={handlePhoneChange}
              placeholder="+234 123 456 7890"
            />
            {formErrors.phone && (
              <div className="text-[#B70303]">{formErrors.phone}</div>
            )}
          </div>
          <div className="emailInput lg:mt-0 mt-5">
            <label htmlFor="hospitalName" className="lg:text-lg text-sm">
              Country
            </label>
            <select
              name="country"
              className="input"
              onChange={(e) => {
                setSelectedCountry(e.target.value);
                setSelectedState(""); // Reset state selection when country changes
                setCities([]); // Reset cities when country changes
              }}
            >
              <option value="">Select Country</option>
              {countries.map((country, index) => (
                <option key={index} value={country.country}>
                  {country.country}
                </option>
              ))}
            </select>
            {formErrors.country && (
              <div className="text-[#B70303]">{formErrors.country}</div>
            )}
          </div>
        </div>

        <div className="flex flex-col lg:flex-row lg:justify-between justify-between gap-2   lg:min-w-full  mx-auto mt-5">
          <div className="emailInput lg:mt-0 mt-5">
            <label htmlFor="cityOfOperation" className="lg:text-lg text-sm">
              State
            </label>
            <select
              name="state"
              className="input"
              onChange={(e) => setSelectedState(e.target.value)}
              disabled={!selectedCountry} // Disable if no country is selected
            >
              <option value="">Select State</option>
              {selectedCountry === "Nigeria" && (
                <option value="Federal Capital Territory">Abuja</option>
              )}
              {states
                .filter((state) => state.state_code !== "NG-FC")
                .map((state, index) => {
                  const stateName =
                    state.name === "Federal Capital Territory"
                      ? "Abuja"
                      : state.name;
                  return (
                    <>
                      <option key={index} value={stateName}>
                        {stateName}
                      </option>
                    </>
                  );
                })}
            </select>
            {formErrors.state && (
              <div className="text-[#B70303]">{formErrors.state}</div>
            )}
          </div>

          <div className="prefferedMode w-full">
            <label
              htmlFor="prefferedMode"
              className=" w-12/12 text-sm lg:text-lg"
            >
              City
            </label>
            <select
              name="city"
              className="w-full h-10 border-[2px] border-[#CFD1D6] rounded-[10px] p-2 bg-transparent  focus:outline-2 focus:outline-[#B70303]"
              disabled={!selectedState}
            >
              <option value="">Select City</option>
              {cities.map((city, index) => (
                <option key={index} value={city}>
                  {city}
                </option>
              ))}
            </select>
            {formErrors.city && (
              <div className="text-[#B70303]">{formErrors.city}</div>
            )}
          </div>
        </div>
        <div className="lg:min-w-full  flex flex-col lg:flex-row lg:justify-between justify-between  mx-auto  gap-1 mt-4 ">
          <div className="prefferedMode w-full">
            <label
              htmlFor="prefferedMode"
              className=" w-12/12 text-sm lg:text-lg"
            >
              Preferred Mode
            </label>
            <select
              name="preference"
              className="w-2/3 h-10 border-[2px] border-[#CFD1D6] rounded-[10px] p-2 bg-transparent  focus:outline-2 focus:outline-[#B70303]"
              onChange={handleInputChange}
              value={formValues.preference || options[0].value}
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {formErrors.preference && (
              <div className="text-[#B70303]">{formErrors.preference}</div>
            )}
          </div>

          <div className="appointmentDate  relative">
            <label htmlFor="appointmentDate" className="text-sm lg:text-lg">
              Appointment Date
            </label>
            <BsCalendarDate className="h-6 w-6 left-2 absolute lg:top-9 top-7 md:top-7 z-10 " />
            <DatePicker
              name="date"
              className="w-full h-10 z-0 border-[2px] border-[#CFD1D6] rounded-[10px] placeholder:text-gray-500 pl-12 bg-transparent focus:outline-2 focus:outline-[#B70303]"
              autoFocus={false}
              placeholderText="Select date"
              dateFormat="dd-MM-yyyy"
              value={selectedDate}
              onChange={handleDateChange}
              minDate={new Date()}
              filterDate={excludeWeekends}
            />
          </div>

          <TimePicker
            name={"time"}
            onChange={handleInputChange}
            value={formValues.time}
            error={formErrors.time}
          />
        </div>
        <div className="lg:flex lg:justify-end lg:items-center lg:min-w-full  mt-8  lg:mr-6 gap-6 ">
          {/* <button
            className="btn-save text-white mb-2"
            type="button"
            onClick={saveDraft}
          >
            Close
          </button> */}
          <button
            className="btn mb-2"
            // disabled={isDisabled}
            type="submit"
            onClick={handleBasicDetailsSubmit}
            // onClick={saveDraft}
          >
            {loading ? "Please wait..." : "Next >"}
          </button>
        </div>
      </form>
      <ToastContainer className={"toast-container toast z-[150] "} />
    </>
  );
};
export default BasicInfo;
